import Rails from "@rails/ujs";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.js";
import flatpickr from "flatpickr";

import "@/components/hero_slider";
import initBootstrapValidation from "@/components/bootstrap_validation.js";
import SmartCaptchaFormValidator from "@/components/smart_captcha_form_validator.js";

window.bootstrap = bootstrap;

document.addEventListener("DOMContentLoaded", function () {
  Rails.start();
  new SmartCaptchaFormValidator();
  initBootstrapValidation();
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  tooltipTriggerList.forEach(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))


  flatpickr(".datepicker", {
    altInput: true,
    altFormat: "d-m-Y",
    dateFormat: "Y-m-d",
    allowInput: true,
  });

  const offcanvasElement = document.getElementById('mobileMenu')
  if (offcanvasElement) {
    const offcanvasInstance = new bootstrap.Offcanvas(offcanvasElement)

    const navLinks = offcanvasElement.querySelectorAll('.mobile-nav-link')
    navLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault()
        const href = this.getAttribute('href')

        offcanvasInstance.hide()

        offcanvasElement.addEventListener('hidden.bs.offcanvas', function() {
          window.location.href = href
        }, { once: true })
      })
    })
  }
});
